var _path, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhosMyShopperFilledSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83263 0V0.000849185C6.43102 -9.10007e-05 7.01604 0.178103 7.51146 0.513757C8.00666 0.849291 8.38929 1.326 8.61031 1.88179L10.4012 6.35615H39.0493C39.3378 6.35623 39.6077 6.49942 39.7694 6.73828C39.9312 6.9772 39.9632 7.28137 39.8561 7.54925L33.9254 22.3769C33.7933 22.707 33.4734 22.9237 33.1178 22.9237H16.2827L13.8133 27.8448L13.8124 27.8456C13.7164 28.0367 13.6712 28.2493 13.6808 28.463C13.6904 28.6766 13.7548 28.8842 13.8676 29.0659C13.9804 29.2476 14.1381 29.3973 14.3253 29.5007C14.5125 29.604 14.7229 29.6574 14.9367 29.6561H34.8119C35.292 29.6561 35.6813 30.0456 35.6815 30.5256C35.6815 31.0059 35.2921 31.3952 34.8119 31.3952H14.9427V31.3944C14.4329 31.3967 13.931 31.2697 13.4846 31.0233C13.0368 30.776 12.6599 30.4176 12.39 29.983C12.1203 29.5485 11.9663 29.0521 11.9434 28.5411C11.9204 28.0303 12.0289 27.5221 12.2584 27.0652L14.7932 22.0117L6.99601 2.52802L6.99516 2.52548C6.90298 2.29311 6.7427 2.09334 6.53575 1.95312C6.32885 1.81302 6.0842 1.73858 5.83432 1.73913H0.918393C0.438146 1.73913 0.0488281 1.34981 0.0488281 0.869565C0.0488309 0.38932 0.438147 0 0.918393 0H5.83263ZM16.3353 21.1846H32.5301L37.7645 8.09528H11.0967L16.3353 21.1846Z",
    fill: "url(#paint0_linear_2987_32364)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2791,
    cy: 37.9324,
    r: 2.06522,
    fill: "#002C31"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7596,
    cy: 37.9324,
    r: 2.06522,
    fill: "#002C31"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2987_32364",
    x1: 39.9185,
    y1: 17.7458,
    x2: 9.7545,
    y2: 33.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhosMyShopperFilledSmall);
export default __webpack_public_path__ + "static/media/whos-my-shopper-filled-small.641b0394a1e27feba79db4aa93298bbd.svg";
export { ForwardRef as ReactComponent };